export default __webpack_public_path__ + "static/media/mag4.37f9392d.png";